import { Column } from "@components/Layout";
import { styled } from "solid-styled-components";

export const ErrorFallbackWrapper = styled(Column)`
  background: ${({ theme }) => theme?.colors.error}30;
`;
